import { api } from "@/api"
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { Cotizacion } from "@/shared/types/cotizacion";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

interface SetInitialMonetizacionRequestDetail {
    nombre: string,
    simbolo: string,
    base: boolean,
    relacionConBase: number
}

export interface SetInitialMonetizacionRequest {
    monedas: SetInitialMonetizacionRequestDetail[]
}

export async function setInitialMonetizacion(request: SetInitialMonetizacionRequest): Promise<Cotizacion> {
    await sleep(1000);
    const response = await api.post("monetizacion/initial", request);
    return response.data;
}

export function useSetInitialMonetizacionMutation(mutationConfig: MutationConfig<Cotizacion, SetInitialMonetizacionRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: setInitialMonetizacion,
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["monetizacion", "initial"] });
        },
    })
}

export interface SetInitialMonetizacionMutationProps {
    mutationConfig?: MutationConfig<Cotizacion, SetInitialMonetizacionRequest>,
    children?: (mutationResult: MutationResult<Cotizacion, SetInitialMonetizacionRequest>) => ReactNode
}

export function SetInitialMonetizacionMutation({
    mutationConfig,
    children
}: SetInitialMonetizacionMutationProps) {
    const mutationResult = useSetInitialMonetizacionMutation(mutationConfig);
    return children && children(mutationResult);
}